export default {
  title: '¡Sumemos fuerzas!',
  subtitle: 'Déjanos tus datos y nos comunicaremos en breve:',
  name: 'Nombre',
  namePlaceholder: 'Escribe tu nombre',
  foundation: 'Fundación',
  foundationPlaceholder: 'Escribe el nombre de la fundación',
  email: 'Correo electrónico',
  emailPlaceholder: 'Escribe tu correo electrónico',
  message: 'Mensaje',
  messagePlaceholder: 'Escribe tu mensaje',
  send: 'Enviar',
  errors: {
    emailFormat: 'Correo inválido. Prueba formato nombre@mail.com',
    requiredFields: 'Por favor, complete todos los campos'
  },
  success: {
    title: '¡Muchas gracias!',
    subtitle: 'Brevemente nos pondremos en contacto contigo',
    doneButton: 'Listo'
  }
}

export const en = {
  title: 'Let\'s join forces!',
  subtitle: 'Send us your contact details, and we will contact you as soon as possible',
  name: 'Name',
  namePlaceholder: 'Write your name',
  foundation: 'Foundation',
  foundationPlaceholder: 'Write the name of the foundation',
  email: 'Email',
  emailPlaceholder: 'Write your email',
  message: 'Message',
  messagePlaceholder: 'Write your message',
  send: 'Send',
  errors: {
    emailFormat: 'Invalid email. Try with a name@mail.com format',
    requiredFields: 'Please, complete all fields'
  },
  success: {
    title: 'Thanks!',
    subtitle: 'We will contact you shortly',
    doneButton: 'Done'
  }
}

export const ca = {
  title: 'Sumem forces!',
  subtitle: 'Deixa\'ns les teves dades i ens posarem en contacte en breu',
  name: 'Nom',
  namePlaceholder: 'Escriu el teu nom',
  foundation: 'Fundació',
  foundationPlaceholder: 'Escriu el nom de la fundació',
  email: 'Correu electrònic',
  emailPlaceholder: 'Escriu el teu correu electrònic',
  message: 'Missatge',
  messagePlaceholder: 'Escriu el teu missatge',
  send: 'Envia',
  errors: {
    emailFormat: 'Adreça de correu invàlida. Prova de format nom@mail.com',
    requiredFields: 'Si us plau completa tots els camps'
  },
  success: {
    title: 'Moltes gràcies!',
    subtitle: 'Ens posarem en contacte amb tu en la major brevetat possible',
    doneButton: 'Fet'
  }
}
